import React from "react";
import Image from "@components/Image";
import cx from "classnames";
import styles from "./PeopleAndCulture.module.scss";
import { usePageContext } from "@providers/PageProvider";
import _ from "lodash";
import { sustainabilityPage } from "@utils/helper";

export default function FeaturedImage() {
  const { pageData } = usePageContext();
  const imageSection = sustainabilityPage.formatImageSection(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex justify-center", styles.featuredImageSection)}
    >
      <Image
        wrapperProps={{ className: cx(styles.featuredImage) }}
        {...imageSection}
        alt={imageSection?.alt || "Careers featured image"}
        layout="fill"
        objectFit="cover"
      />
    </div>
  );
}
